import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { formatInTimeZone } from 'date-fns-tz';
const API_URL = process.env.REACT_APP_API_URL;
const AvailableJobsPage = () => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const navigate = useNavigate();
  
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchAvailableJobs = async () => {
    if (!token) { setLoading(false); return; }
    try {
      setLoading(true); setError('');
      const response = await fetch(`${API_URL}/api/dashboard/jobs/available`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        throw new Error(t('error_fetch_jobs'));
      }
      const data = await response.json();
      setJobs(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableJobs();
  }, [token, t]);

  const handleTakeJob = async (jobId) => {
    if (!window.confirm(t('confirm_take_job', 'Bu işi üzerinize almak istediğinizden emin misiniz?'))) {
        return;
    }
    try {
        const response = await fetch(`${API_URL}/api/dashboard/jobs/${jobId}/take`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) {
            const data = await response.json();
            throw new Error(t(data.messageKey) || t('error_take_job', 'İş alınamadı.'));
        }
        alert(t('success_job_taken', 'İş başarıyla üzerinize atandı!'));
        navigate('/dashboard/jobs'); // Kullanıcıyı "Tüm İşlerim" sayfasına yönlendir
    } catch (err) {
        alert(err.message);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return formatInTimeZone(new Date(dateString), 'Europe/Istanbul', 'dd.MM.yyyy HH:mm');
  };

  const renderContent = () => {
    if (loading) {
      return <div className="table-row-message"><i className="fas fa-spinner fa-spin"></i> {t('loading_jobs')}</div>;
    }
    if (error) {
      return <div className="table-row-message error">{error}</div>;
    }
    if (jobs.length === 0) {
      return (
        <div className="table-row-message">
          {t('no_available_jobs_found')}
        </div>
      );
    }
     return jobs.map(job => {
      // DÜZELTME: 'translator_fee' değerini sayıya çeviriyoruz.
      // Eğer değer null veya geçersizse, 0 olarak kabul edilir.
      const feeAsNumber = parseFloat(job.translator_fee) || 0;

      return (
        <div className="table-row" key={job.id}>
          <div>
              <strong>{job.source_lang.toUpperCase()} → {(Array.isArray(job.target_langs) ? job.target_langs : JSON.parse(job.target_langs)).join(', ').toUpperCase()}</strong><br/>
              <small>{t(job.expertise)} - {job.word_count} {t('words', 'kelime')}</small>
          </div>
          <div>{formatDate(job.deadline)}</div>
          {/* DÜZELTME: Artık güvenli bir şekilde sayıya çevrilmiş değişkeni kullanıyoruz. */}
          <div>{feeAsNumber.toFixed(2)} TL</div>
          <div><button onClick={() => handleTakeJob(job.id)} className="details-btn take-job-btn">{t('take_job_btn', 'İŞİ AL')}</button></div>
        </div>
      );
    });
  };

  return (
    <div className="dashboard-page">
      <div className="page-header">
        <h1>{t('dashboard_available_jobs')}</h1>
        <button onClick={fetchAvailableJobs} className="btn-refresh" disabled={loading}>
            <i className={`fas fa-sync-alt ${loading ? 'fa-spin' : ''}`}></i> {t('refresh', 'Güncelle')}
        </button>
      </div>
      
     <div className="jobs-list-container">
        <div className="jobs-table available-jobs-table">
          <div className="table-header">
            <div>{t('description')}</div>
            <div>{t('deadline')}</div>
            <div>{t('amount')}</div>
            <div></div>
          </div>
          <div className="table-body">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvailableJobsPage;